import { memo } from 'react';
import type { LedgerEntry } from './types';

/**
 * The ledger's Reference cell. L03: a payment taken at a till shows its
 * receipt number and store ("PAY-20261104-0001 · T1A"); every other line keeps
 * its reference id.
 */
export const LedgerReference = memo(function LedgerReference({
  entry,
}: {
  entry: Pick<LedgerEntry, 'reference_id' | 'receipt_number' | 'location_name'>;
}) {
  if (entry.receipt_number) {
    return (
      <span className="inline-flex items-center rounded-full bg-indigo-50 dark:bg-indigo-900/30 px-2 py-0.5 text-xs font-medium text-indigo-700 dark:text-indigo-300">
        {[entry.receipt_number, entry.location_name].filter(Boolean).join(' · ')}
      </span>
    );
  }
  return (
    <span className="text-xs text-neutral-500 dark:text-neutral-400 font-mono">
      {entry.reference_id ?? '—'}
    </span>
  );
});
